export const educationData = [
    {
        id: 1,
        institution: 'Guru Jambheshwar University Of Science and Technology,Hissar.',
        course: 'Bachelor Degree',
        startYear: '2016',
        endYear: '2020'
    },
    {
        id: 2,
        institution: 'Govt Hr Sec School Sohal,Akhnor.',
        course: 'Higher Secondary',
        startYear: '2015',
        endYear: '2016'
    },
    {
        id: 3,
        institution: 'New Oriental High School Sohal,Akhnoor.',
        course: 'Secondary School',
        startYear: '2014',
        endYear: '2015'
    },
]